import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';
import Header from './header';
import BottomFooter from './bottomFooter';
import Navigation from './navigation';
import News from './news';
import FinanceFlash from './aside/financeFlash';
import FinanceHotList from './aside/financeHotList';

const Layout = ({ content }) => {
    const { nav, footer, logo = {}, channelNav = [], modules = [], financeFlash = {}, financeHotList = {} } = content;
    const title = logo.title || '原创';

    return (
        <div className={styles.layout}>
            <Header content={nav} />
            <header className={styles.pageHeader}>
                <div className={styles.logoBox}>
                    {logo.src ? (
                        <a className={styles.logoLink} href={logo.url || '//www.ifeng.com/'} aria-label="返回凤凰网首页">
                            <img className={styles.logoImg} src={logo.src} alt="凤凰网" />
                        </a>
                    ) : null}
                    <h1 className={styles.pageTitle}>{title}</h1>
                    <a className={styles.homeLink} href="//www.ifeng.com/">
                        凤凰网首页
                    </a>
                </div>
                <Navigation content={channelNav} />
            </header>
            <main className={styles.main}>
                <div className={styles.content}>
                    <div className={styles.contentLeft}>
                        {modules.map(mod => (
                            <News key={mod.id} content={{ head: mod.head, list: mod.list, sectionId: mod.id }} />
                        ))}
                    </div>
                    <aside className={styles.contentRight}>
                        <FinanceFlash content={financeFlash} />
                        <FinanceHotList content={financeHotList} />
                    </aside>
                </div>
            </main>
            <BottomFooter content={footer} />
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
